"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/components/site-menu/component");
const client_1 = require("@rws-framework/client");
const component_2 = require("@front/layouts/default-layout/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="style-list-page">
    <crud-table :isItemUneditable="${x => x.isStyleUneditable}"
      :forceItemEditable="${x => x.forceStyleEditable}" :onDataLoaded="${x => x.onDataLoaded}"
      title="${'style.listTitle'.t()}" addText="${'style.addStyle'.t()}" resource="style"
      searchPlaceholder="${'style.searchPlaceholder'.t()}" listEndpoint="style.list" deleteEndpoint="style.delete"
      queryParam="q" :actions="${x => x.baseActions}" editRoute="/settings/style/edit/:id" addRoute="/settings/style/create"
      :columns="${x => x.tableColumns}">
    </crud-table>
  </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.style-list-page .crud-table {
  min-height: 500px;
}
.style-list-page .table th, .style-list-page .table td {
  vertical-align: middle;
}
.style-list-page .badge {
  font-size: 0.8rem;
}`;
const shadowOptions = { "mode": "open" };
let StyleList = class StyleList extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.styleData = [];
        this.title = 'style.listTitle';
        this.addText = 'style.addStyle';
        this.loading = false;
        this.baseActions = [
            {
                key: 'preview',
                icon: 'simple-icon-magnifier',
                label: '',
                variant: 'info',
                tooltip: 'style.tooltips.preview'.t(),
                tooltipDirection: 'top',
                handler: async (id) => {
                    this.previewStyle.bind(this)(id);
                }
            }
        ];
        this.tableColumns = [
            {
                key: 'name',
                header: 'style.name'.t()
            },
            {
                key: 'description',
                header: 'style.description'.t(),
                formatter: (value) => {
                    if (!value)
                        return '-';
                    return value.length > 100 ? value.substring(0, 100) + '...' : value;
                }
            },
            {
                key: 'prompt',
                header: 'style.prompt'.t(),
                formatter: (value) => {
                    if (!value)
                        return '-';
                    return value.length > 150 ? value.substring(0, 150) + '...' : value;
                }
            },
            {
                key: 'common',
                header: 'style.common'.t(),
                formatter: (value) => {
                    return value ? 'common.yes'.t() : 'common.no'.t();
                }
            },
            {
                key: 'active',
                header: 'style.active'.t(),
                formatter: (value) => {
                    return value ? 'common.yes'.t() : 'common.no'.t();
                }
            }
        ];
        this.onDataLoaded = (data) => {
            this.styleData = data;
        };
    }
    get isUserSuperAdmin() {
        var _a;
        return ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
    }
    get isUserParentOrAdmin() {
        var _a, _b, _c;
        return ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN || ((_b = component_2.DefaultLayout.USER) === null || _b === void 0 ? void 0 : _b.role) === backendImport_1.UserRoles.PARENT_USER || ((_c = component_2.DefaultLayout.USER) === null || _c === void 0 ? void 0 : _c.role) === backendImport_1.UserRoles.ENTERPRISE;
    }
    async connectedCallback() {
        super.connectedCallback();
        this.isStyleUneditable = (key, row) => {
            // Super admin can edit everything
            if (this.isUserSuperAdmin)
                return false;
            // Parent users can edit their own styles but not common styles
            if (this.isUserParentOrAdmin) {
                return row.common === true && !this.isUserSuperAdmin;
            }
            // Regular users cannot edit any styles
            return true;
        };
        this.forceStyleEditable = (key, row) => {
            return false; // No forced editing for styles
        };
    }
    previewStyle(id) {
        component_1.SiteMenu.goto.bind(this)(`/settings/style/preview/${id}`);
    }
    addStyle() {
        component_1.SiteMenu.goto.bind(this)('/settings/style/create');
    }
    editStyle(id) {
        component_1.SiteMenu.goto.bind(this)(`/settings/style/edit/${id}`);
    }
};
exports.StyleList = StyleList;
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], StyleList.prototype, "isStyleUneditable", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], StyleList.prototype, "forceStyleEditable", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], StyleList.prototype, "styleData", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], StyleList.prototype, "title", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], StyleList.prototype, "addText", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], StyleList.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], StyleList.prototype, "baseActions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], StyleList.prototype, "tableColumns", void 0);
exports.StyleList = StyleList = __decorate([
    (0, client_1.RWSView)('style-list', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], StyleList);
StyleList.defineComponent();
